<template>
  <div id="page-customer-billing">
    <h5 class="m-4 page-header"> >> {{ $t('AUTH.MENU.CUSTOMER_BILLING') }}</h5>

    <CustomerBillingTHSInvoiceModal
      :next_invoice_date="next_invoice_date"
      :license_fee="local_license_fee"
      :amount_transactions="amount_transactions"
      :index_pct="local_index_pct"
      
      :id="selected_id"
      ref="ths-invoice-modal"

      @created="ths_invoice_created"
      @updated="ths_invoice_updated"
    />

    <CustomerBillingTransactionListModal 
      :type="selected_type"
      ref="customer-transactions-modal"
    />

    <m-row>
      <m-col lg="4">
        <memlist-card>
          
          <m-row>
            <m-col lg="12">
              <h4>Nästa faktura</h4>

              <memlist-date-picker
                class="mt-4"
                :title="`Nästa fakturadatum`"
                :disabled="!isTHS"
                v-model="next_invoice_date"
                @input="update_billing"
              />

              <memlist-text-input
                class="mt-4"
                :title="`Årslicens`"
                :disabled="!isTHS"
                v-model="local_license_fee"
                @input="update_billing"
              />

              <memlist-text-input
                class="mt-4"
                :title="`Beräknade rörliga kostnader`"
                :disabled="true"
                v-model="amount_transactions"
                @input="update_billing"
              />

              <memlist-text-input
                class="mt-4"
                :title="`Indexjustering %`"
                :disabled="!isTHS"
                v-model="local_index_pct"
                @input="update_billing"
              />
              
            </m-col>
            <m-col lg="8">
              
            </m-col>
          </m-row>

          <m-row v-if="isTHS" class="mt-4">
            <m-col lg="6">
              <memlist-button variant="success" @click="create_invoice_clicked">Skapa faktura</memlist-button>
            </m-col>
          </m-row>
          
        </memlist-card>
      </m-col>
      <m-col lg="8">
        <memlist-card style="max-width: 400px;" class="mx-auto">
          <h2 style="font-size: 22px; color: #333333;" class="ml-8 mt-8">Beräknad faktura: {{ calc_invoice_amount }} SEK</h2>
          <p style="font-style: italic; color: #888888;" class="ml-8 ">{{ next_invoice_date }}</p>
        </memlist-card>

        <memlist-card class="mt-4">
          <memlist-static-table
            id="ths-invoices-table"
            :fields="ths_invoice_fields"
            :items="ths_invoices"
            ref="ths-invoices-table"
          >
          <template #cell(is_paid)="row">
            <memlist-badge
              v-if="row.item.is_paid"
              status="success"
              
            >
              {{ $t('INVOICE.PAYMENT_STATUSES.PAID_IN_FULL') }}
              
            </memlist-badge>

            <memlist-badge
              v-else
              status="danger"
            >
              {{ $t('INVOICE.PAYMENT_STATUSES.NOT_PAID') }}
            </memlist-badge>

          </template>

          
          <template #cell(actions)="data">

            <div class='d-flex justify-content-end' >
              
              <memlist-table-button class="mr-2" @click="edit_ths_invoice_clicked(data.item)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')"/>
              <memlist-table-button v-if="isTHS" @click="delete_ths_invoice_clicked(data.item)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />

            </div>
          </template>
          </memlist-static-table>
        </memlist-card>
        
      </m-col>
    </m-row>

    <m-row class="mt-8">
      <m-col lg="3">
        <memlist-card>
          <m-row>
            <m-col lg="12">
              <h4>Transaktioner</h4>
            </m-col>
          </m-row>
          
          <m-row>
            <m-col lg="6">
              <memlist-text-input
                class="mt-4"
                :title="`Swish %`"
                v-model="local_swish_pct"
                :disabled="!isTHS"
                @input="update_billing"
              />
              
            </m-col>
            <m-col lg="6">
              <memlist-text-input
                class="mt-4"
                :title="`Swish @ SEK`"
                v-model="local_swish_fee"
                :disabled="!isTHS"
                @input="update_billing"
              />
            </m-col>
          </m-row>

          <m-row>
            <m-col lg="6">
              <memlist-text-input
                class="mt-4"
                :title="`Stripe %`"
                v-model="local_stripe_pct"
                :disabled="!isTHS"
                @input="update_billing"
              />
            </m-col>
            <m-col lg="6">
              <memlist-text-input
                class="mt-4"
                :title="`Stripe @ SEK`"
                v-model="local_stripe_fee"
                :disabled="!isTHS"
                @input="update_billing"
              />
            </m-col>
          </m-row>

          <m-row>
            <m-col lg="12">
              <h5 class="mt-4">Totalt SEK: {{ total_payments }}</h5>
              <p><a @click.prevent="show_details('ONLINE_PAYMENT')" href="">Detaljer</a></p>
            </m-col>
          </m-row>

          
        </memlist-card>  
      </m-col>
      <m-col lg="3">
        <memlist-card>
          <m-row>
            <m-col lg="12">
              <h4>SMS</h4>
            </m-col>
          </m-row>
          
          <m-row>
            <m-col lg="12">
              <memlist-text-input
                class="mt-4"
                :title="`SMS @ SEK`"
                v-model="local_sms_sek_per_send"
                :disabled="!isTHS"
                @input="update_billing"
              />
              
            </m-col>
            
          </m-row>

          <m-row>
            <m-col lg="12">
              <memlist-text-input
                class="mt-4"
                :title="`SMS Budget per månad`"
                v-model="local_sms_budget"
                @input="update_billing"
              />
              
            </m-col>
            
          </m-row>

          <m-row>
            <m-col lg="12">
              <h5 class="mt-4">Totalt SEK: {{ total_sms  }}</h5>
              <p><a @click.prevent="show_details('SMS')" href="">Detaljer</a></p>
            </m-col>
          </m-row>

        </memlist-card>  
      </m-col>
      <m-col lg="3">
        <memlist-card>
          <m-row>
            <m-col lg="12">
              <h4>BankID</h4>
            </m-col>
          </m-row>
          
          
          <m-row>
            <m-col lg="12">
              <memlist-text-input
                class="mt-4"
                :title="`BankID @ SEK`"
                v-model="local_bankid_fee"
                :disabled="!isTHS"
                @input="update_billing"
              />
              
            </m-col>
            
          </m-row>

          <m-row>
            <m-col lg="12">
              <h5 class="mt-4">Totalt SEK: {{ total_bankid }}</h5>
              <p><a @click.prevent="show_details('BANKID')" href="">Detaljer</a></p>
            </m-col>
          </m-row>

        </memlist-card>
      </m-col>
      <m-col lg="3">
        <memlist-card>

          <m-row>
            <m-col lg="12">
              <h4>SPAR</h4>
            </m-col>
          </m-row>

          <m-row>
            <m-col lg="12">
              <memlist-text-input
                class="mt-4"
                :title="`SPAR Budget per månad`"
                v-model="local_spar_budget"
                @input="update_billing"
              />
              
            </m-col>
            
          </m-row>

          <m-row>
            <m-col lg="12">
          
              <p>Se kontrakt för prislista.</p>
              <h5>Totalt SEK: {{ total_spar }}</h5>

              <p><a @click.prevent="show_details('SPAR')" href="">Detaljer</a></p>

            </m-col>
          </m-row>
          
        </memlist-card>
      </m-col>
    </m-row>
  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import CustomerBillingTransactionListModal from '@/view/pages/ml/customer_billing/CustomerBillingTransactionListModal.vue';
import CustomerBillingTHSInvoiceModal from '@/view/pages/ml/customer_billing/CustomerBillingTHSInvoiceModal.vue';

export default {
  name: 'CustomerBilling',
  components: {
    CustomerBillingTransactionListModal,
    CustomerBillingTHSInvoiceModal,
  },
  mixins: [ toasts ],
  data() {
    return {

      debounce_timer: null,
      ths_invoices: [],
      ths_invoice_fields: [
        {
          key: 'invoice_nr',
          label: this.$t('TRANSACTION.THS_INVOICE.INVOICE_NR'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short4',
          thClass: 'td-short4'
        },
        {
          key: 'amount',
          label: this.$t('TRANSACTION.THS_INVOICE.AMOUNT'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short4',
          thClass: 'td-short4'
        },
        {
          key: 'due_date',
          label: this.$t('TRANSACTION.THS_INVOICE.DUE_DATE'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short3',
          thClass: 'td-short3',
          formatter: (_, __, item) => {
            return dayjs(item.due_date).format('YYYY-MM-DD');
          }
        },
        {
          key: 'is_paid',
          label: this.$t('TRANSACTION.THS_INVOICE.IS_PAID'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short3',
          thClass: 'td-short3',
        },
        {
          key: 'actions',
          label: ' ',
          tdClass: 'td-short3',
          thClass: 'td-short3',
        },
      ],

      total_payments: 0,
      total_spar: 0,
      total_bankid: 0,
      total_sms: 0,
      total_invoice: 0,

      selected_id: null,

      local_license_fee: null,
      local_index_pct: null,
      next_invoice_date: null,
      
      selected_type: 'spar',

      local_swish_pct: null,
      local_stripe_pct: null,
      local_swish_fee: null,
      local_stripe_fee: null,
      local_sms_sek_per_send: null,
      local_sms_budget: null,
      local_spar_budget: null,
      local_bankid_fee: null,

      billing_id: null,

      amount_transactions: null,
    };
  },
  watch: {
    
    currentCompanyId(newValue, oldvalue) {
      
    },
    currentPeriodId(newValue, oldvalue) {
      
    }
  },
  async mounted() {
    this.fetch_calc_all_transactions();
    this.fetch_summary_transactions();
    this.fetch_billing();
    this.fetch_ths_invoices();
  },
  computed: {
    calc_invoice_amount() {
      let amount = 0;

      amount += Math.round(parseFloat(this.amount_transactions+'') || 0);
      amount += Math.round((parseFloat(this.local_license_fee+'') || 0) + (parseFloat(this.local_license_fee+'') || 0) * ((parseFloat(this.local_index_pct+'') || 0) / 100));

      return amount;
    },

    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'isTHS']),
  },

  methods: {
    ths_invoice_updated(item) {
      const index = this.ths_invoices.findIndex(i => i.id === item.id);

      if (index >= 0) {
        this.ths_invoices[index] = item;
        this.ths_invoices = [ ...this.ths_invoices ];
      }
    },
    ths_invoice_created(item) {
      this.ths_invoices.unshift(item);
    },
    
    edit_ths_invoice_clicked(item) {
      console.log(item);
      this.selected_id = item.id;

      this.$nextTick(()=>{
        this.$refs['ths-invoice-modal'].show();
      });
      
    },
    
    async delete_ths_invoice_clicked(item) {
      const res = await axios.delete(`/billing/ths_invoice/${item.id}`);

      if (res.status === 204) {
        this.ths_invoices = this.ths_invoices.filter(i => i.id !== item.id);
      }
    },
    
    get_services_for_type(type) {
      let services = [];

      switch (type) {
        case 'SMS': {
          services = ['sinch'];
          break;
        }
        case 'SPAR': {
          services = ['spar'];
          break;
        }
        case 'INVOICE': {
          services = ['manual_payment','bg','memlist_invoice'];
          break;
        }
        case 'ONLINE_PAYMENT': {
          services = ['swish','epassi','stripe'];
          break;
        }
        case 'BANKID': {
          services = ['bankid'];
          break;
        }
        
      }
      
      return services;
    },

    async fetch_summary_transactions() {
      this.total_sms = await this.fetch_transactions_for_type('SMS');
      this.total_payments = await this.fetch_transactions_for_type('ONLINE_PAYMENT');
      this.total_bankid = await this.fetch_transactions_for_type('BANKID');
      this.total_invoice = await this.fetch_transactions_for_type('INVOICE');
      this.total_spar = await this.fetch_transactions_for_type('SPAR');
      
    },

    async fetch_transactions_for_type(type) {

      const body = {
        modules: ['REGISTER','RENEW','SENDOUT','EVENT','SETTLEMENT','LOGIN'],
        services: this.get_services_for_type(type),

        from_date: '2020-01-01',
        to_date: '2099-12-31',
      };

      const res = await axios.post(`/transaction/count`, body);

      if (res.status === 200) {
        return Math.round(res.data.amount);
      }
  
    },

    create_invoice_clicked() {
      this.selected_id = null;
      
      this.$nextTick(()=>{
        this.$refs['ths-invoice-modal'].show();
      });
      
    },

    async update_billing() {
      if (!this.billing_id) {
        return;
      }

      clearTimeout(this.debounce_timer);

      this.debounce_timer = setTimeout(async () => {
        const res = await axios.put(`/billing/${this.billing_id}`, {
          stripe_pct:       this.local_stripe_pct * 100,
          swish_pct:        this.local_swish_pct * 100,
          swish_fee:        this.local_swish_fee * 100,
          stripe_fee:       this.local_stripe_fee * 100,
          sms_sek_per_send: this.local_sms_sek_per_send,
          bankid_fee:       this.local_bankid_fee * 100,
          next_invoice_date: this.next_invoice_date,
          license_fee:      this.local_license_fee * 100,
          index_pct:        this.local_index_pct * 100,
          sms_budget:       this.local_sms_budget,
          spar_budget:      this.local_spar_budget,
        });

        if (res.status === 204) {
          console.log('updated');
          this.toastr('success', this.$t('COMMON.OK'), this.$t('BILLING.UPDATED'));
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('BILLING.UNABLE_UPDATE'));
        }
      }, 500); 

    },

    async fetch_calc_all_transactions() {
      const body = {
        modules: ['REGISTER','RENEW','SENDOUT','EVENT','SETTLEMENT','LOGIN'],
        services: ['spar','sinch','dintero','manual_payment','epassi','bg','stripe','swish','bankid','memlist_invoice'],

        from_date: '2020-01-01',
        to_date: '2099-12-31',
      };

      const res = await axios.post(`/transaction/count`, body);

      if (res.status === 200) {
        this.amount_transactions = res.data.amount;
      }
  
    },

    async fetch_billing() {
      const res = await axios.get(`/billing/active/${this.currentCompanyId}`);

      if (res.status === 200) {
        const billing = res.data;

        this.local_stripe_pct = (billing.stripe_pct || 0) / 100;
        this.local_swish_pct = (billing.swish_pct || 0) / 100;
        this.local_swish_fee = (billing.swish_fee || 0) / 100;
        this.local_stripe_fee = (billing.stripe_fee || 0) / 100;
        this.local_sms_sek_per_send = (billing.sms_sek_per_send || 0);
        this.local_bankid_fee = (billing.bankid_fee || 0) / 100;
        this.billing_id = billing.billing_id;
        this.local_spar_budget = (billing.spar_budget || 0);
        this.local_sms_budget = (billing.sms_budget || 0);

        this.next_invoice_date = billing.next_invoice_date;
        this.local_index_pct = (billing.index_pct || 0) / 100;
        this.local_license_fee = (billing.license_fee || 0) / 100;
      }
    },

    async fetch_ths_invoices() {
      const res = await axios.get(`/billing/ths_invoices`);

      if (res.status === 200) {
        this.ths_invoices = res.data;
      }
    },

    show_details(type) {
      this.selected_type = type;
      this.$refs['customer-transactions-modal'].show();
    }
  },
  
};
</script>
